import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class BringozPackageSelectComponent implements IController {

  form: any;
  selectedType: any;
  name: string;
  optionIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  isHideLabels: boolean;
  isHideValidSelectionError: boolean;
  onChange: Function;

  public selectedPackage: any;
  public selectedText: any;
  public sitePackageItemsMap: any;

  constructor(private $mdPanel, private splitService) {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
  }

  $onInit() {
    if (!this.name) {
      this.name = 'packageList';
    }
    this._setSelected();
  };

  $onChanges(changes) {
    if (
      (changes.selectedType && !changes.selectedType.isFirstChange()) ||
      (changes.optionIds && !changes.optionIds.isFirstChange())
    ) {
      this._setSelected();
      if (this.optionIds) {
        this.checkValidity();
      }
    }
  };

  $postLink() {
    if (this.optionIds) {
      this.checkValidity();
    }
  }

  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedTypeRef = this.selectedType;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedTypeRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'package';
        this.selectedTypeRef = selectedTypeRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedType) => {
        if (selectedType === 'clickOutsideToClose' || selectedType === 'escapeToClose') {
          selectedType = selectedTypeRef;
        }

        if (!selectedType) {
          this.onChange({selectedPackage: undefined, selectedType: undefined});
          panel.destroy();
        } else {
          const packageItem = angular.copy(this.sitePackageItemsMap[selectedType]);
          this.onChange({selectedPackage: packageItem, selectedType: selectedType});
          panel.destroy();
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({selectedPackage: undefined, selectedType: undefined});
  }

  private checkValidity() {

    if (!this.form || this.isHideValidSelectionError) {
      return;
    }

    const isSelectedTypeInOptions = _.findIndex(this.optionIds, (itemSize) => {
      return itemSize === this.selectedType;
    })

    if (isSelectedTypeInOptions < 0) {

      this.form[this.name].$setValidity('isValid', false);
      this.form[this.name].$touched = true;
    } else {
      this.form[this.name].$setValidity('isValid', true);
    }
  }

  private _setSelected() {
    if (!!this.selectedType && this.optionIds) {
      this.selectedPackage = angular.copy(this.sitePackageItemsMap[this.selectedType]);
    } else {
      this.selectedPackage = undefined;
    }
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozPackageSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedType: '<',
      optionIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      isHideLabels: '<?',
      isHideValidSelectionError: '<?',
      ngPlaceholder: '@?',
      name: '@?',
      onChange: '&',
    },
    template: require('./bringoz-package-select.html').default,
    controller: BringozPackageSelectComponent
  });
